module.exports = __webpack_public_path__ + "img/btn_menu_province_c.f6da9115.png";